export const STATUS_PAGES = {
    notSupported: 'notsupported',
    notConnected: 'notconnected',
} as const;

export const STATUS_ROUTES = {
    notSupported: `/:id/${STATUS_PAGES.notSupported}`,
    notConnected: `/:id/${STATUS_PAGES.notConnected}`,
} as const;
